import { render, staticRenderFns } from "./StationKunMingDetail.vue?vue&type=template&id=36093ac0&scoped=true&"
import script from "./StationKunMingDetail.vue?vue&type=script&lang=ts&"
export * from "./StationKunMingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StationKunMingDetail.vue?vue&type=style&index=0&id=36093ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36093ac0",
  null
  
)

export default component.exports